import axios from 'axios';
import SimulacaoPrevidencia from '../support';

const api = axios.create({
  baseURL: SimulacaoPrevidencia().bUSA,
});

api.interceptors.request.use((request: any) => {
//   const token = localStorage.getItem('@SolicitacaoAtendimento:token');

//   if (token) {
//     request.headers.common['x-auth-token'] = token;
//   }

  request.headers.common['x-api-token'] = SimulacaoPrevidencia().hashHeader;
  //request.headers.common['Access-Control-Allow-Origin'] = '*';

  return request;
});

api.interceptors.response.use((response) => {
  return response;
});

export default api;
